import React from 'react';
import { CurrentUser } from '@uplift/api';
import { useQueryClient } from '@tanstack/react-query';

export const CurrentuserContext = React.createContext<CurrentUser | null>(null);


export const useCurrentuser = () => {
  const currentUser = React.useContext(CurrentuserContext);

  if (!currentUser) {
    // this is for backward compatibility
    // need to replace with error later
    // throw new Error('No Current User data');
    return {} as CurrentUser;
  }

  return currentUser;
};


export const useCurrentuserRefetch = () => {
  const queryClient = useQueryClient();

  return {
    refetchUser: async () => {
      await queryClient.invalidateQueries([ 'me' ]);
    }
  };
};
